/**
 * SPDX-License-Identifier: MPL-2.0
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2023 (c) Daniel Littfinski, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import { createAction, Dispatch } from '@reduxjs/toolkit';
import { PutCompanyReq } from 'Api/generated';
import Api from 'Api/Api';
import { Company } from 'Api/generated';

export const CompanyDataActionTypes = {
  Query: 'Company_Query',
  Queried: 'Company_Queried',
  Update: 'Company_Update',
  Updated: 'Company_Updated',
  Create: 'Company_Create',
  Created: 'Company_Created',
  Delete: 'Company_Delete',
  Deleted: 'Company_Deleted',
};

export const CompanyAction = {
  Query: createAction(CompanyDataActionTypes.Query),
  Queried: createAction<Company[]>(CompanyDataActionTypes.Queried),
  Update: createAction(CompanyDataActionTypes.Update),
  Updated: createAction<Company>(CompanyDataActionTypes.Updated),
  Create: createAction(CompanyDataActionTypes.Create),
  Created: createAction<PutCompanyReq>(CompanyDataActionTypes.Created),
  Delete: createAction<string>(CompanyDataActionTypes.Delete),
  Deleted: createAction<string>(CompanyDataActionTypes.Deleted),
};

export class CompanyDataActions {
  static QueryCompanys() {
    return function (dispatch: Dispatch) {
      dispatch(CompanyAction.Query());
      Api.Company.getCompanies().then((data) => dispatch(CompanyAction.Queried(data.data)));
    };
  }

  static CreateCompany(Company: PutCompanyReq) {
    return function (dispatch: Dispatch) {
      dispatch(CompanyAction.Create());
      Api.Company.addCompany(Company)
        .then(() => {
          dispatch(CompanyAction.Created(Company));
        })
        .catch(() => {
          console.error('Could not CreateCompany');
        });
    };
  }

  static DeleteCompany(company: Company) {
    return function (dispatch: Dispatch) {
      if (company.Id === undefined) {
        console.error('Delete Company without ID not possible.');
        return;
      }
      dispatch(CompanyAction.Delete(company.Id));
      Api.Company.deleteCompany(company.Id).then(() => dispatch(CompanyAction.Deleted(company.Id!)));
    };
  }

  static UpdateCompany(CompanyName: Company) {
    return function (dispatch: Dispatch) {
      if (CompanyName.Id === undefined) {
        console.error('Company without ID not possible.');
        return;
      }
      dispatch(CompanyAction.Update());
      Api.Company.editCompany(CompanyName.Id, CompanyName).then(() => dispatch(CompanyAction.Updated(CompanyName)));
    };
  }
}
